export default [
  {
    path: "/message/:msgId",
    name: "message",
    meta: { title: "Message-Details" },
    component: () => import("../views/message/message-details.vue")
  }
]